/**
 * Constants for audit UI components
 */

import type { AsoEngineType } from "@a7y/types";

/**
 * Human-readable display labels for ASO engine types
 */
export const ENGINE_DISPLAY_LABELS: Record<AsoEngineType, string> = {
  events: 'Events',
  content: 'Metadata',
  audit: "Full Audit",
  screenshot: "Screenshots",
  keyword: "Keywords",
  icon: "Icon",
  competitor: "Competitors",
  sentiment: "Reviews & Sentiment",
  keywordService: "Keyword Service",
  storetext: "Store Text",
  intent: "Intent Mapping",
  aiDiscovery: "AI Discoverability",
  searchTerm: "Search Terms",
  l11nAnalysis: "Language Coverage",
  reviews_backfill: "Reviews Backfill",
};
